import React , { useState, useRef, useEffect } from 'react'; 

import WidgetHeader from "../preview/headerNew"; 
import HeaderJSON from "../components/headerNew.json"; 
import WidgetFooter from "../preview/footerNew"; 
import FooterJSON from "../components/footerNew.json"; 
import data from '../components/icons';
import {NavForm,SwiperHeader, PaddingComponent, BackgroundWidget, ColorWidget2, ColorWidget, getRootValue, Nouislider, GridWidget, linkPopup} from '../components/helpers'


export default function SettingsEditor(props) {
    const [data, setData] = useState({
        data:{
            header:HeaderJSON,
            footer:FooterJSON
        }
    });
     useEffect(() => {
            
            
            
     
        }, [])

        const {header} = data.data;
       

    return <div className='settings-editor w-100 h-100'>
        <div className='settings-view'>
            <div className='w'>
                <WidgetHeader data={data.data.header} mode={"live"} device={"desktop"} />
                <WidgetFooter data={data.data.footer} mode={"live"} device={"desktop"} />
            </div>
        </div>
        <div className='editor-panel p-3'>
            <h4>Header Editor</h4>

           <div className="card">
  <div className="card-header">
    Logo
  </div>
   <div className="card-body">
     <div className="form-check form-switch d-flex m-0 p-0 pt-3 align-items-center pb-3">
                                            <label className="form-check-label label m-0" for="typelogo">Logo Image</label>
                                            <input type="checkbox" className="form-check-input ms-auto mt-0" id="typelogo" name="typelogo" checked={header.elements.logo.showLogo} />
                                          </div>
                                          <img type="button" src={header.elements.logo.properties.src} style={{height:"60px"}} />

                                          

{
    
    ["textSize", "fontFamily", "textColor", "showLogo"].map(function(v){
        let value = header.elements.logo.properties[v];
        let input = "";
        if(v === "textColor") {
          input = <input type='color' value={value}  />                          
        }

        return <div className={`itemContainer`}>
          <label className="d-block fw-bold col-12">{v}</label>
          {input}
        </div>

        return 
                                          <div className={`itemContainer`}>
                                      <label className="d-block fw-bold col-12">Size</label>
                                      <Nouislider range={{ min: 0, max: 50 }} step="1" start={header.elements.logo.properties.logoDimension} connect={"lower"} connectColor="#3899ED" handleColor="#E2F2FF" callback={function(nextId, nextValue){
                                        
                                      }}/>
                                    </div>  

    })
}

   </div>

</div>


<div className="card" style={{width: '18rem'}}>
  <div className="card-header">
    Navigation
  </div>
   <div className="card-body"></div>
  
</div>

<div className="card" style={{width: '18rem'}}>
  <div className="card-header">
    Social Icons
  </div>
   <div className="card-body"></div>
  
</div>

<div className="card" style={{width: '18rem'}}>
  <div className="card-header">
    Button
  </div>
   <div className="card-body"></div>
  
</div>

        </div>
    </div>
}